export const LAUNCH_ENTERPRISE_CHAT = 'LAUNCH_ENTERPRISE_CHAT';

/**
 * Launch enterprise chat action
 * @param {string} [chatInitOrigin] - Optional origin identifier for the chat (e.g., 'app', 'error_modal')
 * @returns {{type: string, payload: {chatInitOrigin: string}}} Redux action
 */
export const launchEnterpriseChat = (chatInitOrigin) => ({
  type: LAUNCH_ENTERPRISE_CHAT,
  payload: { chatInitOrigin },
});
